import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const headerComponent = {
  backButton: 'header.back-button',
  drawerButton: 'header.drawer-button',
  logoImage: 'header.logo-image',
  progress: 'header.progress',
  root: 'header.root',
} as const satisfies ComponentLocatorMap;
